import { emptyLocation } from '@features/forms/CaseForms/config';
import { ORGAN_TYPES } from '@features/components/CaseFormBlocks/config';
import { CaseStatus, OrganType, ServiceType } from '@/api/apis/case';
import { TrialProgram } from '@/api/apis/facilities/trial-programs';
import { Location } from '@/api/types';
import { LocationFormType } from '@/types';
import { getLocationAddress, hasActiveTrialProgram } from '@/utils/helpers';

export const shouldUncheckOpoRequest = (
  caseStatus: CaseStatus | undefined,
  organType: OrganType,
  txCenterTrialPrograms?: TrialProgram[],
) => !caseStatus && hasActiveTrialProgram(organType, txCenterTrialPrograms);

const ALL_ORGAN_TYPES = ORGAN_TYPES.map((organ) => organ.value);

export const getAvailableOrganTypes = ({
  canCreateKidneyCase,
  isEditDraft,
  originalOrganType,
  currentOrganType,
}: {
  canCreateKidneyCase: boolean;
  isEditDraft?: boolean;
  originalOrganType?: OrganType;
  currentOrganType?: OrganType;
}): OrganType[] => {
  if (canCreateKidneyCase) return ALL_ORGAN_TYPES;

  const isExistingKidneyCaseUnchanged =
    isEditDraft && originalOrganType === OrganType.Kidney && currentOrganType === OrganType.Kidney;

  if (isExistingKidneyCaseUnchanged) return ALL_ORGAN_TYPES;

  return ALL_ORGAN_TYPES.filter((organType) => organType !== OrganType.Kidney);
};

export const getLocationPayload = (
  location?: Location,
  resolveSubdivisionName?: (stateCode?: string | null, countryCode?: string | null) => string | undefined,
) => {
  let payload: LocationFormType = emptyLocation;
  if (location) {
    const { id, ...locationProps } = location;
    const hospitalAddress = getLocationAddress(location, resolveSubdivisionName);
    payload = {
      addressId: id,
      title: hospitalAddress,
      ...locationProps,
    };
  }
  return payload;
};

type DonorOrRequiredParams = {
  serviceType?: ServiceType | null;
  status?: CaseStatus | null;
};

export const isDraftCaseStatus = (status?: CaseStatus | null): boolean =>
  !status || status === CaseStatus.Draft || status === CaseStatus.TXCenterDraft;

export const isDirectAcquisitionCase = (serviceType?: ServiceType | null): boolean =>
  serviceType === ServiceType.DirectAcquisition;

export const getDonorOrRequired = ({ serviceType, status }: DonorOrRequiredParams): boolean => {
  const isDaCase = isDirectAcquisitionCase(serviceType);
  const isDraftStatus = isDraftCaseStatus(status);

  if (isDaCase) return true;

  return !isDraftStatus;
};
